import React from "react";
import { Navigate } from "react-router-dom";
import consoleLogger from "./Utils/logger";

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error: error };
	}

	componentDidCatch(error, errorInfo) {
		// Log the error (gets intercepted and stored)
    console.error('React Component Error', {
      message: error.toString(),
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    });

    // Send logs to API
    consoleLogger.sendLogsToAPI().catch(err => 
      console.error('Failed to send error logs:', err)
    );
	}

	render() {
		if (this.state.hasError) {
			//window.localStorage.removeItem("tabId");
			return <Navigate to="/error" state={this.state.error} />;
			// You can render any custom fallback UI
			// return <h1>Something went wrong.</h1>;
		}

		return this.props.children;
	}
}
